'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const discoveryURIMap = {
  "test-1": "https://discovery.dev.tekoapis.net/api",
  dev: "https://discovery.dev.tekoapis.net/api",
  stag: "https://discovery.stag.tekoapis.net/api",
  production: "https://discovery.tekoapis.com/api"
};
const DEFAULT_PRODUCT_LIST = {
  limit: 10,
  type: "grid",
  itemSettings: {
    priceColor: "rgb(235, 31, 58)"
  },
  responsiveSettings: {
    desktop: {
      gap: 4,
      itemsPerRow: 5
    },
    mobile: {
      gap: 4,
      itemsPerRow: 2
    }
  },
  carouselSettings: {
    desktop: {
      paginationColor: "rgba(37, 141, 255, 1)",
      paginationPosition: "inside",
      gridRows: 1,
      gridCols: 5
    },
    mobile: {
      paginationColor: "rgba(37, 141, 255, 1)",
      paginationPosition: "inside",
      gridRows: 1,
      gridCols: 2.5
    }
  },
  button: {
    text: "Xem th\xEAm",
    buttonStyle: {
      backgroundColor: "rgba(37, 141, 255, 1)",
      color: "rgba(255, 255, 255, 1)",
      height: 32,
      width: 120,
      borderRadius: 999
    },
    iconConfig: {
      position: "left",
      spacing: 8,
      show: true,
      icon: {
        size: 24
      }
    },
    commonStyle: {
      justifyContent: "center"
    }
  }
};
const DEFAULT_PRODUCT_LIST_HEADING = {
  text: '<h4 style="text-align: center;">Danh s\xE1ch s\u1EA3n ph\u1EA9m</h4>'
};

exports.DEFAULT_PRODUCT_LIST = DEFAULT_PRODUCT_LIST;
exports.DEFAULT_PRODUCT_LIST_HEADING = DEFAULT_PRODUCT_LIST_HEADING;
exports.discoveryURIMap = discoveryURIMap;
